/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import style from './App.module.scss';
import './constants/_global.scss';
import HomePage from './pages/homePage/homePage';
import Header from './pageParts/header/header';
import { AppInterface } from './AppTypes';
import PopUpLogin from './pageParts/popUp/popUpLogin';
import {
  LoginInterface,
  POP_UP_LOGIN_TYPE,
  RegistrationInterface,
} from './pageParts/popUp/popUpTypes';
// import { fakeDataListings } from './constants/fakeDataListings';
import {
  ListingDataInterface,
  MODAL_TYPES,
  UserInterface,
} from './constants/constants';
import ListingPage from './pages/listingPage/listingPage';
import CreateListingPage from './pages/createListingPage/createListingPage';
import EditListingPage from './pages/editListningPage/editListingPage';
import PopUpRegistration from './pageParts/popUp/popUpRegistration';
import ProfilePage from './pages/profilePage/profilePage';
import { useDispatch, useSelector } from './index';
import { setError, signOut } from './service/UserData';
import {
  getListings,
  getOwnFavoriteListings,
  getOwnListings,
  setPageNumber,
} from './service/ListingData';
import AdminPage from './pages/adminPage/adminPage';

const App: React.FC<AppInterface> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userId = useSelector((state) => state.userData.user.id);
  const isUser = useSelector((state) => state.userData.isLogin);
  const [isModal, setIsModal] = useState<MODAL_TYPES | null>(null);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const state = location.state as { previousLocation?: Location };
  const [prevLocation, setPrevLocation] = useState<string>('/');
  const [loginType, setLoginType] = useState<POP_UP_LOGIN_TYPE>(
    POP_UP_LOGIN_TYPE.ON_CLICK
  );
  const userData = useSelector((state) => state.userData.user);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsLogin(isUser);
  }, [isUser]);

  const [currentListingData, setCurrentListingData] =
    useState<ListingDataInterface | null>(null);

  const closePopUp = (step: number) => {
    navigate(step);
    setIsModal(null);
    dispatch(setError(null));
  };

  const onLogoClick = () => {
    dispatch(setPageNumber(1));
    dispatch(getListings(1));
    navigate('/');
    setIsModal(null);
  };

  const logOut = () => {
    dispatch(signOut({ token: 'TOKEN' }));
    dispatch(setPageNumber(1));
    dispatch(getListings(1));
    navigate('/');
  };

  const listingClick = (id: number) => {
    navigate(`/listing/${id}`);
  };

  const logIn = (type: POP_UP_LOGIN_TYPE) => {
    dispatch(setPageNumber(1));
    dispatch(getListings(1));
    setLoginType(type);
    setPrevLocation(location.pathname);
    navigate('/login', { state: { previousLocation: location } });
    setIsModal(MODAL_TYPES.LOG_IN);
  };

  const createListing = async () => {
    if (!isLogin) {
      logIn(POP_UP_LOGIN_TYPE.SUGGESTED);
    } else {
      navigate('/create-lisiting');
    }
  };

  const editListning = (id: number) => {
    navigate(`/edit-listing/${id}`);
  };

  const deleteListing = (id: number) => {
    navigate('/');
  };

  const registration = async () => {
    await setIsModal(MODAL_TYPES.REGISTRATION);
    navigate('/regiatration', { state: { previousLocation: prevLocation } });
  };

  const returnToLogin = () => {
    setIsModal(MODAL_TYPES.LOG_IN);
    navigate('/login', { state: { previousLocation: prevLocation } });
  };

  const toRegistrate = (data: RegistrationInterface) => {
    console.log(`Data: ${data}`);
  };

  const onAvatrClick = () => {
    dispatch(getOwnListings(1));
    dispatch(getOwnFavoriteListings(1));
    navigate('/profile');
  };

  const listListing = (
    data: ListingDataInterface[],
    userId: number
  ): ListingDataInterface[] => {
    const listings: ListingDataInterface[] = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i]?.owner === userId) {
        listings.push(data[i]);
      }
    }
    return listings;
  };

  // const listFavorite = (
  //   data: ListingDataInterface[],
  //   userId: number
  // ): ListingDataInterface[] => {
  //   const listings: ListingDataInterface[] = [];
  //   for (let i = 0; i < data.length; i++) {
  //     const favoriteList = data[i].idFavorite;
  //     for (let j = 0; j < favoriteList.length; j++) {
  //       if (favoriteList[j] === userId) {
  //         listings.push(data[i]);
  //         break;
  //       }
  //     }
  //   }
  //   return listings;
  // };

  return (
    <div className={style.app}>
      <Header
        isLogin={isLogin}
        onAdd={createListing}
        onExit={logOut}
        onLogo={onLogoClick}
        onLogin={() => logIn(POP_UP_LOGIN_TYPE.ON_CLICK)}
        onAvatarClick={onAvatrClick}
      />
      <Routes location={state?.previousLocation || location}>
        <Route
          path="/"
          element={
            <HomePage
              isLogin={isLogin}
              logOut={() => console.log('logout')}
              createLicting={() => console.log('create')}
              maxListings={6}
              modal={isModal}
              closePopupLogin={() => {
                closePopUp(-1);
              }}
              closePopupRegistration={() => {
                closePopUp(-2);
              }}
              afterLogin={closePopUp}
              afterRegistration={closePopUp}
              loginType={loginType}
              listingClick={listingClick}
              onCardEdit={editListning}
              onRegistration={toRegistrate}
              onNoAccount={registration}
              returnToLogin={returnToLogin}
            />
          }
        />
        <Route
          path="/listing/:id"
          element={
            <ListingPage
              data={currentListingData!}
              isLogin={isLogin}
              toEdit={editListning}
              toLogin={() => logIn(POP_UP_LOGIN_TYPE.SUGGESTED)}
              toDelete={deleteListing}
              closePopupLogin={() => {
                closePopUp(-1);
              }}
              closePopupRegistration={() => {
                closePopUp(-2);
              }}
              afterLogin={closePopUp}
              afterRegistration={closePopUp}
              loginType={loginType}
              modal={isModal}
              onNoAccount={registration}
              onRegistration={toRegistrate}
              returnToLogin={returnToLogin}
            />
          }
        />
        <Route path="/admin" element={<AdminPage />} />
        <Route
          path="/create-lisiting"
          element={<CreateListingPage data={null} />}
        />
        <Route
          path="/edit-listing/:id"
          element={<EditListingPage data={currentListingData} />}
        />
        <Route
          path="/profile"
          element={
            <ProfilePage
              // userListningData={listListing(fakeDataListings, userData.id)}
              // favoriteData={listFavorite(fakeDataListings, userData.id)}
              onEdit={editListning}
              onProfileEdit={(data) => console.log(data)}
              listingClick={listingClick}
            />
          }
        />
        {!state?.previousLocation && (
          <Route
            path="/login"
            element={
              <PopUpLogin
                type={loginType}
                error={false}
                onClose={() => {
                  closePopUp(-1);
                }}
                onNoAccount={registration}
                onSubmit={closePopUp}
              />
            }
          />
        )}
        {!state?.previousLocation && (
          <Route
            path="/registration"
            element={
              <PopUpRegistration
                error={false}
                onSubmit={closePopUp}
                onClose={() => {
                  closePopUp(-2);
                }}
                toLogin={() => {
                  navigate('/login');
                }}
              />
            }
          />
        )}
      </Routes>
      <div className={style.linkBlock}>
        <Link to="/" className={`subtitle ${style.link}`}>
          Документация
        </Link>
        <Link to="/" className={`subtitle ${style.link}`}>
          О нас
        </Link>
        <Link to="/" className={`subtitle ${style.link}`}>
          Правила платформы
        </Link>
      </div>
    </div>
  );
};
export default App;
